import React, { ReactElement } from 'react'
import { shortenAddress } from '@/utils/shortenAddress'
import { formatDateString } from '@/utils/formatting'
import { Transaction } from '@/database/transaction'
import { TransactionActivity, TransactionStatus } from '@/database/types'

const expirationText = (isActive: boolean, transaction: Transaction) => {
    if (transaction.activity === TransactionActivity.INACTIVE) {
        return 'de-activated'
    }
    return isActive ? 'valid until' : 'expired at'
}

const HistoryOffer = ({ transaction }: { transaction: Transaction }): ReactElement => {
    const isActive =
        new Date(Date.now()) < new Date(transaction.expiration) && transaction.activity !== TransactionActivity.INACTIVE

    return (
        <ul>
            {transaction.activity !== TransactionActivity.ACCEPTED && (
                <span>
                    <span className="gray">
                        {transaction.status !== TransactionStatus.TRANSFERRED ? `${transaction.status} ` : ''}
                        {transaction.type}&nbsp;
                    </span>
                    <span className={isActive ? 'white' : 'light-gray'}>{transaction.amount}</span>
                    <span className="gray">&nbsp;by&nbsp;</span>
                    <span className={isActive ? 'white' : 'light-gray'}>
                        {shortenAddress(transaction.sender)}&nbsp;
                    </span>
                    <span className="gray">&nbsp;at&nbsp;</span>
                    <span className={isActive ? 'white' : 'light-gray'}>
                        {formatDateString(transaction.createdAt)}&nbsp;
                    </span>
                    <span className="gray">&nbsp;{expirationText(isActive, transaction)}&nbsp;</span>
                    <span className={isActive ? 'white' : 'light-gray'}>
                        {formatDateString(
                            transaction.activity !== TransactionActivity.INACTIVE
                                ? transaction.expiration.toString()
                                : transaction.updatedAt.toString(),
                        )}
                        &nbsp;
                    </span>
                </span>
            )}{' '}
            &&{' '}
            {transaction.activity === TransactionActivity.ACCEPTED && (
                <span>
                    <span className="white">{transaction.type}&nbsp;</span>
                    <span className={'white'}>{transaction.amount}</span>
                    <span className="gray">&nbsp;by&nbsp;</span>
                    <span className={'light-gray'}>{shortenAddress(transaction.sender)}&nbsp;</span>
                    <span className="gray">&nbsp;at&nbsp;</span>
                    <span className={'light-gray'}>{formatDateString(transaction.createdAt)}&nbsp;</span>
                    <span className="gray">&nbsp;{'accepted by'}&nbsp;</span>
                    <span className={'light-gray'}>{shortenAddress(transaction.owner)}&nbsp;</span>
                    <span className="gray">&nbsp;at&nbsp;</span>
                    <span className={'light-gray'}>{formatDateString(transaction.updatedAt)}&nbsp;</span>
                </span>
            )}
        </ul>
    )
}

export default HistoryOffer
